import { CommonModule } from '@angular/common';
import { HttpContext } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SVModule } from '@delon/abc/sv';
import { ALLOW_ANONYMOUS } from '@delon/auth';
import { _HttpClient, SettingsService } from '@delon/theme';
import { QRCodeModule } from 'angularx-qrcode';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-uuid-modal',
  templateUrl: './uuid-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    NzInputModule,
    NzButtonModule,
    NzIconModule,
    FormsModule,
    NzDividerModule,
    NzModalModule,
    SVModule,
    NzSpinModule,
    NzTabsModule,
    NzTableModule,
    NzTypographyModule,
    NzTagModule,
    NzToolTipModule,
    QRCodeModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EInvoiceUuidModalComponent {
  private http = inject(_HttpClient);
  activeTab = 0;
  visible = false;

  @Input() status = '';
  @Output() readonly statusChange = new EventEmitter<string>();
  loading = false;
  data: any = {};
  tenantId: string | null = null;

  constructor(
    private cdr: ChangeDetectorRef,
    private settings: SettingsService
  ) { }

  showLhdnDocument(uuid: string, timeout: number = 0) {
    if (!uuid) return;

    this.tenantId = this.settings.user['company']?.tenantId
    this.visible = true;
    this.loading = true;
    this.data = {};
    this.cdr.detectChanges();

    setTimeout(() => {
      this.http
        .get('api/einvoices/lhdnDocument', 
          { tid: this.tenantId as string, uuid: uuid }, 
          {
          context: new HttpContext().set(ALLOW_ANONYMOUS, true)
          }
        )
        .pipe(finalize(() => (this.loading = false)))
        .subscribe(res => {
          this.loading = false;
          this.data = res;
          this.cdr.detectChanges();

          if (res.status && res.status !== this.status) {
            this.status = res.status;
            this.statusChange.emit(res.status);
            this.cdr.detectChanges();
          }
        });
    }, timeout);
  }

  showLhdnDocumentWithData(respData: any) {
    this.visible = true;
    this.data = respData;
    this.cdr.detectChanges();
  }

  get url() {
    if (!this.data.longId || !this.data.uuid) return '';
    const einvPortalUlr = this.data.isLive
      ? 'https://myinvois.hasil.gov.my'
      : 'https://preprod.myinvois.hasil.gov.my';
    return `${einvPortalUlr}/${this.data.uuid}/share/${this.data.longId}`;
  }
}
